import { TASK_STATUS } from "../../utils/constant";
import CustomCheckBox from "../CustomCheckBox";
import { format } from "date-fns";
import { isEmpty } from "lodash";
import MarkComplete from "components/common/modal/MarkComplete";
import allImgPaths from "assets/images";
import { useEffect, useState } from "react";
import useAppState from "context/useAppState";
import Toast from "components/common/Toast";
import { useParams } from "react-router-dom";

const CardTask = (props: any) => {
  const { id } = useParams();
  const { task } = props;
  const { setState: setTaskState, updateTask } = useAppState("taskHook");
  const { currentEventId } = useAppState("boardData");
  const {
    boardData,
    updateBoardCallApiFlag,
    cards: cardList,
    columns,
    updateState,
  } = useAppState("cardWrapper");
  const { setState: setEventData } = useAppState("eventData");

  const [showMarkComplete, setIsShowMarkComplete] = useState<boolean>(false);

  const handleChange = async (name: string, check: boolean) => {
    setTaskState({ currentSelectedTask: task });

    if (task?.is_completed) {
      let blockId: any, cardId: any;
      boardData?.map((block: any) => {
        block?.cards.map((card: any) => {
          card?.tasks.map((cardTask: any) => {
            if (cardTask?._id === task?._id) {
              blockId = block?._id;
              cardId = card?._id;
            }
          });
        });
      });
      const payload = {
        task_id: task?._id,
        block_id: blockId,
        card_id: cardId,
        is_completed: !task?.is_completed,
      };

      const _cardList = [...cardList];
      const copyColumns = [...columns];
      const index = copyColumns.findIndex((col) => col.id === blockId);

      if (index >= 0) {
        copyColumns[index].isSelected = true;

        _cardList.map((item: any) => {
          if (blockId === item.columnId) {
            item.isSelected = copyColumns[index].isSelected;

            item.tasks.map((taskItem: any) => {
              if (task._id === taskItem._id) {
                task.is_completed = false;
              }
            });
          }
        });
      }

      updateState({ column: copyColumns, cards: _cardList });
      await updateTask(id, payload);
      // await updateTask(currentEventId, payload)
      //updateBoardCallApiFlag(true)
    } else {
      setIsShowMarkComplete(!showMarkComplete);
    }
    setEventData({
      toast: {
        show: true,
        message: task?.is_completed
          ? "Task has been marked as pending."
          : "Task has been marked as completed.",
        heading: "Task updated successfully!",
      },
    });
  };

  return (
    <div className="pl-3.5 card-children mb-4 last:mb-0">
      <div className="flex items-center">
        <span className="card-child-checkbox flex gap-x-2">
          <CustomCheckBox 
            name={task._id} 
            checked={task.is_completed} 
            onChange={handleChange} 
          />
          <span
            className="text-[#373738] text-sm font-interMedium self-start mt-[3px]"
            key={task._id}
          >
            {task.title}
          </span>
        </span>
        {showMarkComplete && (
          <MarkComplete setisShowMarkComplete={setIsShowMarkComplete} task_id={task._id} />
        )}
        <span className="font-interMedium text-sm text-[#F154FF] pl-2">{task?.tags}</span>
      </div>

      {/* Date */}
      {task?.due_date !== null || task?.reminder_date !== null ? (
        <div className="flex items-center justify-between pt-2.5">
          {task?.due_date !== null && (
            <span className="font-interMedium text-xs text-[#667085] flex gap-x-1 items-center">
              <img src={allImgPaths.calenderCheckCardIcon} alt="" />
              {format(new Date(task.due_date), "dd MMMM yyyy")}
            </span>
          )}

          {task?.reminder_date !== null && (
            <span className="font-interMedium text-xs text-[#667085] flex gap-x-1 items-center">
              <img src={allImgPaths.bellDotCardIcon} alt="" />
              {format(new Date(task.reminder_date), "dd MMMM yyyy")}
            </span>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CardTask;
